export default __webpack_public_path__ + "static/1_20-90a1a95780df37a7ef478fbf66fc2224.png";